(() => {
  'use strict';

  const FLAG = '__entinaAiodCartBridgeV22';
  if (window[FLAG]) return;
  window[FLAG] = true;

  const KEEP_OPEN_MS = 3000;
  const REFRESH_GUARD_MS = 1200;

  let keepOpenUntil = 0;
  let refreshGuardUntil = 0;

  const getDrawer = () =>
    window.ecxCartDrawer ||
    document.getElementById('ecxCartDrawer') ||
    document.querySelector('ecx-cart-drwr');

  const isOpen = (drawer) => Boolean(drawer?.hasAttribute('open'));

  const isExitAction = (target) => Boolean(target?.closest?.(
    '#cartDrawer .js-cart-drawer-btn-close,' +
    '#cartDrawer .js-cart-drawer-overlay,' +
    '#cartDrawer .js-cart-drawer-submit-btn,' +
    '#cartDrawer .drawer__footer a'
  ));

  const armKeepOpen = (target) => {
    const drawer = getDrawer();
    if (!isOpen(drawer) || !drawer.contains(target) || isExitAction(target)) return;
    keepOpenUntil = Date.now() + KEEP_OPEN_MS;
  };

  document.addEventListener('pointerdown', (event) => {
    armKeepOpen(event.target);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') armKeepOpen(event.target);
  }, true);

  const previousTriggerCartOpen = window.triggerCartOpen;

  window.triggerCartOpen = function (...args) {
    const drawer = getDrawer();
    const shouldKeepOpen = isOpen(drawer) || Date.now() < keepOpenUntil;

    if (!shouldKeepOpen) {
      if (typeof previousTriggerCartOpen === 'function') {
        return previousTriggerCartOpen.apply(this, args);
      }
      return true;
    }

    const now = Date.now();
    if (now >= refreshGuardUntil) {
      refreshGuardUntil = now + REFRESH_GUARD_MS;
      document.dispatchEvent(new CustomEvent('cart:update', {
        detail: { source: 'aiod', timestamp: now }
      }));
    }

    if (drawer && typeof drawer.openDrawer === 'function') drawer.openDrawer();
    return true;
  };
})();
